import { interceptFetchResponse } from './intercept-fetch-response.js'

// Dependencies
import * as mIntercom from '../modules/intercom/intercom.js'
import * as mReferrals from '../../helpers/referrals/referrals.js'
import * as mFooter from '../modules/footer/footer.js'
import * as mUser from '../modules/user/user.js'
import { loadOneOrganisation } from '../modules/user/organisations.js'
import { appAccount } from '../modules/user/account.js'
import { browserAppAccount } from '../helpers/app-data-loaders/app-account.js'
import { browserAppUser } from '../helpers/app-data-loaders/app-user.js'

import '../modules/pg-header-login/index.js'
import { showPageHeaderMenu } from '../modules/header-menu/menu.js'

// Track that User has been loaded (So navigating from one page to another does not force a reload)
let isUserLoaded = false
let isPageLoaded = false

interceptFetchResponse(browserAppUser)

/**
 *
 * @param {Object} params
 * @param {String} [params.accountId]
 * @param {String} [params.orgId]
 * @param {Boolean} [params.loadUser]
 * @param {Boolean} [params.loadChartOfAccounts]
 * -- PG data
 * @param {String} [params.appAccountId] PG appAccountId
 * @param {Boolean} [params.includeEntities] PG loadEntities()
 * @param {Boolean} [params.includeCurrencies] PG loadCurrenciesForAccount()
 */
export async function loadPageStarter (params = {}) {
  console.log('*** loadPageStarter', 'isUserLoaded?', isUserLoaded, params)

  mFooter.loadFooter()

  mReferrals.readReferrer()

  // Load User by default
  const isForceLoadUser = params.loadUser === true
  const isDefaultLoadUserWhenNotAlready = typeof params.loadUser === 'undefined' && !isUserLoaded
  if (isForceLoadUser || isDefaultLoadUserWhenNotAlready || !isPageLoaded) {
    await mUser.loadUser()
    console.log('*** loadPageStarter loadUser() then')
    isUserLoaded = true
  } else {
    console.log('not loadUser()')
  }

  if (params.accountId) {
    localStorage.setItem('accountId', params.accountId)
    await appAccount.load(params.accountId)
  } else {
    appAccount.useAccount(null)
  }

  if (params.orgId) {
    localStorage.setItem('orgId', params.orgId)
    await loadOneOrganisation(params.orgId)
  }

  if (params.loadChartOfAccounts) {
    // Disabled Jul 1st 2025: Chart of Accounts is not used anymore
    // await appAccount.addChartOfAccounts()
  }

  if (params.loadCurrencies) {
    await appAccount.addFXrates()
  }

  // TODO: update accountData() when not on an account related page?
  showPageHeaderMenu({ browserAppAccount, browserAppUser })

  if (!isPageLoaded) {
    mIntercom.bootIntercom()
  } else {
    mIntercom.recordPage()
  }

  isPageLoaded = true

  console.log('*** loadPageStarter done **')
}

// function launchGoogleAnalytics () {
//   console.log('launchGoogleAnalytics?', window.location)
//   if (window.location.hostname === 'localhost') return
//   if (window.location.hostname.includes('staging')) return

//   console.log('launch Analytics')
//   gtag('config', 'G-XXX')
// }

// launchGoogleAnalytics()
